import { render, staticRenderFns } from "./PromoterRank.vue?vue&type=template&id=ba858c14&scoped=true&"
import script from "./PromoterRank.vue?vue&type=script&lang=js&"
export * from "./PromoterRank.vue?vue&type=script&lang=js&"
import style0 from "./PromoterRank.vue?vue&type=style&index=0&id=ba858c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba858c14",
  null
  
)

export default component.exports